import type { LaneLodTier } from "./lane.types";

export type LaneLodContext = {
  pxPerSec: number;
};

export function getLaneLodTier(ctx: LaneLodContext): LaneLodTier {
  const { pxPerSec } = ctx;

  if (pxPerSec < 8) return "far";
  if (pxPerSec < 32) return "mid";
  if (pxPerSec < 96) return "near";
  return "micro";
}